import React, { Fragment, useContext, useState, useEffect } from 'react';

import { ComponentContext } from '../../context/componentContext';
import { AuthContext } from '../../context/authContext';

import UnexpectedError from '../../components/UnexpectedError';
import AuthHeader from '../../container/Layout/AuthHeader';
import AuthFooter from '../../container/Layout/AuthFooter';
import { Plain } from '../../components/Loading';

const Verification = ({ history, location }) => {
  document.title = 'CrowdFarmer | Verification';

  const { reload, loading, setLoading, unexpectedError, setUnexpectedError } = useContext(
    ComponentContext
  );
  const { verification, isAuthenticated } = useContext(AuthContext);

  let [success, setSuccess] = useState(null);
  let [error, setError] = useState(null);

  const { search } = location;

  useEffect(() => {
    const queryStr1 = search.split('?')[1];
    const queryStr2 = queryStr1 && queryStr1.split('&');
    if (queryStr2[0] && queryStr2[1]) {
      (async () => {
        setLoading(true);
        try {
          const response = await verification(queryStr2[0], queryStr2[1]);
          if (response.code === 200) {
            setSuccess(response.message);
          } else {
            setError(response.data.message);
          }
        } catch (error) {
          setUnexpectedError('Unexpected Network Error!');
        }
        setLoading(false);
      })();
    } else {
      setError('Link may be broken');
    }
  }, [reload, search, setLoading, setUnexpectedError, verification]);

  return (
    <Fragment>
      <AuthHeader />
      {loading ? (
        <Plain />
      ) : (
        <>
          {unexpectedError ? (
            <UnexpectedError unexpectedError={unexpectedError} />
          ) : (
            <div className="container mx-auto">
              <div className="container-inner mx-auto">
                <div className="flex items-center justify-center h-screen">
                  <div className="text-center">
                    {success && (
                      <>
                        <h3>Verification successful!</h3>
                        <p className="text-xl mb-5 text-gray-700">
                          Kindly login into your account to updated your profile and start farming
                          right away!!!.
                        </p>
                      </>
                    )}
                    {error && (
                      <>
                        <h3>Verification failed!</h3>
                        <p className="text-xl mb-5 text-gray-700">{error}</p>
                      </>
                    )}
                    <button
                      className="bg-cf-300 text-green-200 p-2 rounded shadow-cfw focus:outline-none"
                      onClick={() =>
                        isAuthenticated() ? history.push('/home') : history.push('/')
                      }
                    >
                      Go to login page
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <AuthFooter />
    </Fragment>
  );
};

export default Verification;
